import { ACHIEVEMENTS_DOMAIN, ACHIEVEMENTS_KEY } from '../../constants'

function getAchievementByIdSelector (id) {
  return (state) => {
    return state[ACHIEVEMENTS_DOMAIN][ACHIEVEMENTS_KEY.DATA][id]
  }
}

export default getAchievementByIdSelector
